module.exports = __webpack_public_path__ + "static/media/slideMobile1.4ac0766f.jpg";